"use client";

import { IntercomProvider as ReactUseIntercomProvider } from "react-use-intercom";
import { isAMKProgram, isRBTProgram, isTGProgram } from "../programConstants";
import { usePathname } from "next/navigation";

interface IntercomProviderProps {
  children: React.ReactNode;
}

function IntercomProvider({
  children,
}: IntercomProviderProps): React.JSX.Element {
  const pathname = usePathname();
  // Check if user is on advisor route
  const isAdvisorRoute = pathname?.startsWith("/advisor") ?? false;

  // Check if program is TG or AMK
  const isTGOrAMK = isTGProgram() || isAMKProgram();

  // Show Intercom when:
  // 1. isRBTProgram (always)
  // OR
  // 2. (isAMK OR isTG) AND path is advisor
  // AND
  // 3. env variable exists

  const shouldShowIntercom =
    !!process.env.NEXT_PUBLIC_INTERCOM_APP_ID &&
    (isRBTProgram() || (isTGOrAMK && isAdvisorRoute));

  return (
    <ReactUseIntercomProvider
      appId={
        shouldShowIntercom
          ? (process.env.NEXT_PUBLIC_INTERCOM_APP_ID ?? "")
          : ""
      }
      apiBase={process.env.NEXT_PUBLIC_INTERCOM_API_BASE ?? ""}
      autoBoot={shouldShowIntercom}
      autoBootProps={{
        hideDefaultLauncher: false,
        customLauncherSelector: undefined,
      }}
    >
      {children}
    </ReactUseIntercomProvider>
  );
}

export default IntercomProvider;
